import{jsx as o,Fragment as r}from"react/jsx-runtime";import e from"../img/Eye.svg.js";import t from"../img/EyeClose.svg.js";const m=({color:m="#000",open:s})=>{const i=o(s?t:e,{});return o(r,{children:i})};export{m as default};
